module.exports = __webpack_public_path__ + "img/toolsItem09.cf133830.png";